import { render, staticRenderFns } from "./SliderCards.vue?vue&type=template&id=4645c14d&"
import script from "./SliderCards.vue?vue&type=script&lang=ts&setup=true&"
export * from "./SliderCards.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4645c14d')) {
      api.createRecord('4645c14d', component.options)
    } else {
      api.reload('4645c14d', component.options)
    }
    module.hot.accept("./SliderCards.vue?vue&type=template&id=4645c14d&", function () {
      api.rerender('4645c14d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/doctors/register/index/DoctorsRegisterContent/components/DoctorRates/components/SliderCards.vue"
export default component.exports